<template>
  <el-dialog :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" class="create-project-dialog" width="80vw">
    <div slot="title" class="dialog-title">
      恭喜您！您已完成项目{{ progressPercent }}%的进度，共拿到{{ count }}%的项目比例
    </div>
    <!-- <div>
      <p>以下信息已填写完成</p>
      <div class="hasset-field-box">
        <span v-for="item in hasValueFields" :key="item" class="hasset-field"
          >{{ item }}{{ percentFields[item] ? `（${percentFields[item]}%）` : '' }}</span
        >
      </div>
    </div> -->

    <div v-if="hasNotValueFields.length > 0" class="create-project-alert-box">
      <!-- <p class="dialog-title" style="text-align:left;margin-bottom:4px;">提示</p> -->
      <div class="mb10">
        <span>以下信息还未填写，建议您补充完整，提高您的项目分成比例</span>
        <el-button class="ml10" size="mini" @click="toEdit">补充编辑</el-button>
      </div>
      <p class="mb10">
        不知道该怎么填写？没关系，aki小姐姐来教你，点击下面附件查看教程：
        <!-- <span class="ml10 text-btn">项目立项培训Xmind</span> -->
      </p>
      <p class="mb10">附件教程: <span class="ml10 text-btn" @click="preview">项目立项培训Xmind</span></p>
      <div class="mb10">
        <span>信息问不清楚？生成话术直接问客户</span>
        <el-button class="ml10" size="mini" @click="showProjectTalk">生成问题话术</el-button>
      </div>
      <!-- <div class="hasset-field-box mb10">
        <span v-for="item in hasNotValueFields" :key="item" class="hasset-field warning-text">{{ item }}</span>
      </div> -->
    </div>
    <ProjectTalk ref="ProjectTalk" :company="company" :project="project"></ProjectTalk>

    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="dialogVisible = false">知道了，一会去填</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import { tags } from '../../constant/type'
import ProjectTalk from '../NewCreateProject/ProjectTalk'

export default {
  components: { ProjectTalk },
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
  },
  data() {
    return {
      dialogVisible: false,
      count: 0,
      sendNotify: true,
      hasValueFields: [],
      hasNotValueFields: [],
      percentFields: {
        岗位要求: 0.5,
        岗位职责: 0.5,
        岗位薪酬: 1,
        关键面试人: 1,
        核心要求: 1,
        寻访方向: 1,
        目标公司: 1,
        典型人才: 1,
        项目亮点及优势: 1,
        部门详情: 1,
        面试流程: 1,
        面试辅导: 1,
        可能的问题及应对: 1,
        公司薪酬概况: 1,
      },
      // fields: [
      //   '客户公司',
      //   '对接hr',
      //   '项目名称',
      //   '项目亮点及优势',
      //   '职位劣势及风险点',
      //   '部门详情',
      //   '阿尔法认知',
      //   '一句话简介',
      //   '公司优势',
      //   '公司劣势',
      //   '阿尔法公司认知',
      //   '公司薪酬概况',
      //   '关注问题',
      //   '核心要求',
      //   '面试流程',
      //   '面试辅导',
      //   '面试安排',
      //   '面试地址',
      //   '岗位要求',
      //   '岗位职责',
      //   '岗位薪酬',
      //   '关键面试人',
      //   '职位产生的原因',
      //   '最迟到岗日期',
      //   '招聘难点',
      //   '竞争预警',
      //   '职位话术',
      //   '可能的问题及应对',
      //   '关键人才画像',
      //   '项目成员',
      //   '寻访方向',
      //   '目标公司',
      //   '不倾向公司',
      //   '倾向平台',
      //   '典型人才',
      //   '特殊要求寻访',
      //   '推荐备注',
      //   '特殊要求面试安排',
      // ],
      // specialFields: {
      //   关键人才画像: ['职能模块', '平台', '细分职能', '业绩', '擅长方向', '职级', '目标行业', '地域'],
      //   项目成员: ['客户开发', '项目对接', '项目经理', '项目成员'],
      // },
      // translate: {
      //   一句话简介: '一句话介绍',
      //   面试流程: '项目面试流程',
      //   面试辅导: '项目面试辅导',
      //   面试安排: '公司面试流程',
      //   面试地址: '面试地址',
      //   关键面试人: '关键面试决策人',
      //   部门详情:'部门信息',
      // },
      type: {
        项目基本信息: [
          '客户公司',
          '对接hr',
          '岗位名称',
          '用人部门',
          '办公地点',
          '专业职级',
          '管理职级',
          '工作年限',
          '预计第一批人推荐时间',
          '优先级',
          '招聘数量',
        ],
        项目成员: ['客户开发', '项目对接', '项目经理', '项目成员'],
        人才画像: [
          '职能模块',
          '细分职能',
          '擅长方向',
          '目标行业',
          '倾向年龄',
          '平台',
          '业绩',
          '职级',
          '地域',
          '性别',
          '倾向学历',
          '薪酬范围',
          '语言能力',
          '职业资格',
          '领导力',
          '个人风格',
          '专业因素',
          '心态、个性',
        ],
        职位JD: ['岗位要求', '岗位职责', '岗位薪酬', '关键面试决策人'],
        核心要求: ['核心要求'],
        寻访要求: ['寻访方向', '目标公司', '不倾向公司', '倾向平台', '典型人才'],
        亮点优势: ['项目的亮点优势', '职位劣势及风险点', '部门信息', '阿尔法项目认知'],
        客户公司信息: [
          '一句话介绍',
          '公司优势',
          '公司劣势',
          '阿尔法公司认知',
          '公司薪酬概况',
          '高管介绍',
          '客户特殊要求',
          '客户最关注的问题',
        ],
        必成单分析: ['职位产生的原因', '最迟到岗日期', '招聘难点', '竞争预警'],
        面试辅导: ['项目面试流程', '项目面试辅导', '公司面试流程', '面试地址'],
        项目辅导: ['职位话术', '可能的问题及应对'],
        附件: ['附件信息'],
      },
      label2field: {
        岗位名称: '项目名称',
        用人部门: '部门',
        办公地点: '办公地',
        预计第一批人推荐时间: 'indroduceTime',
        关键面试决策人: '关键面试人',
        项目的亮点优势: '项目亮点及优势',
        阿尔法项目认知: '阿尔法认知',
        一句话介绍: '一句话简介',
        客户最关注的问题: '关注问题',
        项目面试流程: '面试流程',
        项目面试辅导: '面试辅导',
        公司面试流程: '面试安排',
        附件信息: '附件',
        部门信息: '部门详情',
        倾向年龄: '年龄要求',
      },
      specialTag: ['语言能力', '职业资格', '领导力', '个人风格', '专业因素', '心态、个性'],
      progressPercent: 0,
    }
  },
  computed: {
    categories() {
      return app.categories
    },
    xifen() {
      const arr = app.categories.filter(v => this.newRadish.职能模块 && this.newRadish.职能模块.includes(v.名称))
      const cate = []
      arr.forEach(v => cate.push(...(v.二级职能 || [])))
      return [...new Set(cate)]
    },
  },
  methods: {
    open(progressPercent) {
      this.progressPercent = progressPercent || 0
      this.checkFields()
      this.dialogVisible = true
    },
    showProjectTalk() {
      this.$refs.ProjectTalk.open()
    },
    async preview() {
      const file = { md5: '536d644e61198443d4c13b253a72957c' }
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    confirm() {},
    toEdit() {
      this.dialogVisible = false
      this.$emit('toEdit', this.hasNotValueFields)
    },
    toProjectDetail() {
      window.open(`${window.frontend}/#/project20/${this.project._id}`, '_blank')
      if (this.sendNotify) this.sendNotification()
    },
    async sendNotification() {
      const res = await app.service('project').addProjectNotify(this.project._id)
      if (res.status !== 'success') this.$message.error(res.msg)
    },
    checkFields() {
      const { project, percentFields, type, label2field, specialTag } = this
      let result = 0
      const has = []
      const hasNot = []
      Object.keys(type).forEach(label => {
        const fields = type[label]
        fields.forEach(field => {
          const projectField = label2field[field] || field
          const val = project[projectField]
          const percent = percentFields[projectField]
          // if (specialFields[projectField]) {
          //   let flag = false
          //   specialFields[projectField].forEach(v => {
          //     if (Array.isArray(project[v])) {
          //       if (project[v].filter(x => x).length > 0) flag = true
          //     } else if (project[v]) flag = true
          //   })
          //   if (flag) has.push(field)
          //   else hasNot.push(projectField)
          // }
          if (specialTag.includes(field)) {
            const tag = tags.find(v => v.label === field)
            const children = tag.children
            let flag = false
            children.forEach(v => {
              if (project['标签'].includes(v)) flag = true
            })
            if (flag) {
              has.push(field)
              result += percent || 0
            } else hasNot.push(projectField)
          } else if (Array.isArray(val)) {
            if (val.filter(x => x).length > 0) {
              has.push(field)
              result += percent || 0
            } else hasNot.push(projectField)
          } else if (val) {
            has.push(field)
            result += percent || 0
          } else hasNot.push(projectField)
        })
      })

      this.count = result
      this.hasValueFields = has
      this.hasNotValueFields = hasNot
    },
  },
}
</script>
<style>
.create-project-dialog .el-dialog__body {
  padding-top: 0px;
}
</style>
<style scoped src="../../css/newCreateProject.css"></style>
<style scoped>
.hasset-field-box {
  display: flex;
  flex-wrap: wrap;
}
.hasset-field {
  flex: none;
  min-width: 100px;
  margin: 10px;
}
.footer-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.dialog-title {
  font-size: 16px;
  text-align: center;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 8px;
}
.create-project-alert-box {
  border: 1px solid #d4d4d4;
  padding: 10px;
  border-radius: 4px;
}
</style>
